import { useEffect, useState } from 'react';

export function useObservable<T>(observable: Observable<T>) {
    const [value, setValue] = useState<T>(observable.value);
    useEffect(() => {
        observable.add(setValue);
        return () => {
            observable.delete(setValue);
        };
    }, [observable]);
    return value;
}

export function register<T>(observable: Observable<T>, value: T | undefined) {
    useEffect(() => {
        observable.set(value);
        return () => {
            observable.set(undefined);
        };
    }, [observable, value]);
    return value;
}

export class Observable<T> extends Set<
    (newValue: T | undefined, oldValue: T | undefined) => void
> {
    #value: T | undefined;
    set(value: T | undefined) {
        if (this.#value === value) {
            return;
        }
        const old = value;
        this.#value = value;
        for (const hook of this) hook(value, old);
        return value;
    }
    get value() {
        return this.#value;
    }
}
